import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function JoinPage() {
  const navigate = useNavigate();
  const { code } = useParams<{ code: string }>();
  const [playerName, setPlayerName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleJoin = async () => {
    const name = playerName.trim();
    if (!name) {
      setError('Enter your name');
      return;
    }

    if (!code) {
      setError('Invalid session code');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch(`/api/session/${code.toUpperCase()}/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          playerName: name,
          connectionType: 'player',
        }),
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || 'Failed to join');
      }

      const data = await res.json();

      const params = new URLSearchParams({
        playerId: data.playerId,
        host: '0',
      });
      navigate(`/game/${code.toUpperCase()}?${params}`);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to join game');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-100 px-4">
      <div className="max-w-md w-full">
        <button onClick={() => navigate('/')} className="btn btn-ghost btn-sm mb-6">
          &larr; Back
        </button>

        <h1 className="text-3xl font-bold mb-2">Join Game</h1>
        <p className="text-base-content/60 mb-8">
          Session: <span className="font-mono font-bold tracking-widest text-primary">{code?.toUpperCase()}</span>
        </p>

        <div className="space-y-6">
          <div className="form-control">
            <label className="label">
              <span className="label-text text-lg">Your Name</span>
            </label>
            <input
              type="text"
              placeholder="Enter your name"
              value={playerName}
              onChange={(e) => setPlayerName(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleJoin()}
              className="input input-bordered w-full"
              maxLength={20}
              autoFocus
            />
          </div>

          {error && (
            <div className="alert alert-error">
              <span>{error}</span>
            </div>
          )}

          <button
            onClick={handleJoin}
            disabled={loading || !playerName.trim()}
            className="btn btn-primary btn-lg w-full"
          >
            {loading ? <span className="loading loading-spinner" /> : 'Join'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default JoinPage;
